import script from "./Homepage2024Technopolis.vue?vue&type=script&setup=true&lang=js"
export * from "./Homepage2024Technopolis.vue?vue&type=script&setup=true&lang=js"

import "./Homepage2024Technopolis.vue?vue&type=style&index=0&id=f0a2c50c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0a2c50c"]])

export default __exports__